// extracted by mini-css-extract-plugin
export default {"container":"PublicSale_container__Pr2JP","faqItemList":"PublicSale_faqItemList__mn0yi"};